import { getRefundReason } from '../RefundPill/refundInfo'
import { WALLET_PAYMENT_LABEL } from '../../utils/walletPayment'
import formatAmount from '../../utils/formatMoney'

export const MANUAL_REFUND_REASONS = [
  'admin_manual_refund',
  'approved_not_joined',
  'lobby_cancelled',
  'companion_leave',
  'admin_companion_removed'
]

export const refundReasonLabel = reason => getRefundReason(reason)

export const isRefundable = transaction =>
  ['approved', 'authorized'].includes(transaction?.status) && !transaction?.refund

export const refundProblemMessage = (code, detail = {}) => {
  switch (code) {
    case 'already_refunded':
      return 'Esta transacción ya está reembolsada.'
    case 'partially_refunded':
      return 'Ya tiene un reembolso parcial: el resto se devuelve con «Reembolsar restante».'
    case 'not_refundable':
      return `La transacción no está cobrada (${detail.status || 'sin estado'}), no hay nada para devolver.`
    case 'companion_in_lobby':
      return 'El pasajero sigue en el viaje. Usá "Eliminar" sobre el pasajero en el viaje: lo saca, libera el lugar y le devuelve la plata.'
    case 'not_found':
      return 'No existe una transacción con ese ID.'
    case 'refund_failed':
      return detail.message
        ? `Mercado Pago no hizo el reembolso: ${detail.message}`
        : 'No se pudo hacer el reembolso. Probá de nuevo en un rato.'
    case 'awaiting_choice':
      return 'El pasajero todavía está eligiendo cómo recibir este reembolso, no se puede reembolsar desde acá.'
    case 'refund_in_progress':
      return detail.state === 'manual'
        ? 'Ya hay un reembolso para resolver a mano. Revisá Mercado Pago antes de devolver nada.'
        : 'Ya hay un reembolso en curso para esta transacción. Esperá a que termine.'
    case 'already_refunding':
      return 'Otro proceso empezó a reembolsar esta transacción. Recargá para ver cómo quedó.'
    case 'refund_unconfirmed':
      return 'No pudimos confirmar el resultado. Revisá Mercado Pago antes de reintentar.'
    case 'refunds_paused':
      return 'Los reembolsos de pagos con saldo están en pausa. Resolvelo a mano.'
    default:
      return 'No se pudo hacer el reembolso. Probá de nuevo en un rato.'
  }
}

export const paymentMethodLabel = (transaction, walletShare = null) => {
  if (transaction?.alternative_payment === 'deposit') return 'Depósito'
  if (transaction?.alternative_payment) return 'Transferencia'
  if (walletShare === WALLET_PAYMENT_LABEL) return walletShare
  return walletShare ? `Mercado Pago · ${walletShare}` : 'Mercado Pago'
}

export const refundDestinationNote = ({ alternativePayment, walletShare = null }) => {
  if (alternativePayment) {
    return 'Es un pago por transferencia o depósito: queda marcado como reembolsado y llega un mail a Viatik para hacer la devolución a mano.'
  }
  if (walletShare === WALLET_PAYMENT_LABEL) return 'Es un pago con saldo Viatik: vuelve al saldo del pasajero.'
  if (walletShare) {
    return 'La parte pagada con saldo vuelve al saldo del pasajero y el resto se pide a Mercado Pago. Si ya lo devolviste desde el panel de Mercado Pago, sólo se actualiza la base.'
  }
  return 'Se pide el reembolso total a Mercado Pago. Si ya lo devolviste desde el panel de Mercado Pago, sólo se actualiza la base.'
}

export const transactionTotal = transaction => {
  const metadata = transaction?.preference?.metadata || transaction?.metadata || {}
  if (typeof metadata.price === 'number') {
    const { price, fee = 0, discount = 0 } = metadata
    return price + fee - discount
  }
  const items = transaction?.preference?.items
  if (Array.isArray(items) && items.length) {
    return items.reduce((total, item) => total + item.unit_price * item.quantity, 0)
  }
  return 0
}

export const formatMoney = (amount, currency) => formatAmount(amount, currency) ?? '-'
